import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
    steps: {
        display: 'grid',
        gap: 6,
        listStyle: 'none',
        margin: 0,
        padding: 0
    },
    step: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        fontSize: '0.72rem',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
        '&::before': {
            content: '""',
            height: 4,
            borderRadius: 4,
            background: theme.palette.divider
        }
    },
    done: {
        '&::before': { background: theme.palette.text.primary }
    },
    current: {
        color: theme.palette.primary.main,
        '&::before': { background: theme.palette.primary.main }
    }
})

/** A step bar: <FlowSteps steps={['Plan', 'Payment', 'Sign', 'Done']} active={1} />. */
const FlowSteps = ({ classes, steps = [], active = 0 }) => <ol
    className={classes.steps}
    style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}
    aria-label="Progress"
>
    {steps.map((label, i) => <li
        key={label}
        className={[classes.step, i < active ? classes.done : '', i === active ? classes.current : ''].join(' ')}
        aria-current={i === active ? 'step' : undefined}
    >{label}</li>)}
</ol>

export default withStyles(styles)(FlowSteps)
